import { render, staticRenderFns } from "./Somos1BudgetUpload.vue?vue&type=template&id=66a1a38a&scoped=true"
import script from "./Somos1BudgetUpload.vue?vue&type=script&lang=js"
export * from "./Somos1BudgetUpload.vue?vue&type=script&lang=js"
import style0 from "./Somos1BudgetUpload.vue?vue&type=style&index=0&id=66a1a38a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a1a38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a1a38a')) {
      api.createRecord('66a1a38a', component.options)
    } else {
      api.reload('66a1a38a', component.options)
    }
    module.hot.accept("./Somos1BudgetUpload.vue?vue&type=template&id=66a1a38a&scoped=true", function () {
      api.rerender('66a1a38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1BudgetUpload.vue"
export default component.exports